module.exports = __webpack_public_path__ + "img/logo-5-light.f1f804da.png";